import AssignmentsView from '@/assignments/AssignmentsView.vue'
import AssignmentsView2 from '@/assignments/AssignmentsView2.vue'
import AssignmentDetailView from '@/assignments/details/AssignmentDetailView.vue'

export const ASSIGNMENTS_VIEW = {
    componentName: 'AssignmentsView',
    component: AssignmentsView,
    meta: { requiresOrg: true }
}

export const ASSIGNMENTS_VIEW2 = {
    componentName: 'AssignmentsView2',
    component: AssignmentsView2,
    meta: { requiresOrg: true }
}

export const ASSIGNMENT_DETAILS = {
    componentName: 'AssignmentDetailView',
    path: '/AssignmentsView2/:assignmentUuid',
    component: AssignmentDetailView,
    meta: { requiresOrg: true }
}